import PropTypes from "prop-types";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import classNames from "classnames";
import { memo, useState } from "react";

const FlightFilterButton = ({
	className,
	label,
	floatingContent,
	labelClassName = "filter-sort__button-filter",
	floatingOffsetDesk = [-2, -7],
	floatingOffsetMobile = [-2, -10],
	zIndexValue = 10,
	popoverClassName = "filter-sort__button-filter__popover",
	referenceComponent,
	dismissOnFloatingClick = true,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const referenceClasses = classNames(labelClassName);

	const buttonReference = referenceComponent || (
		<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} className={referenceClasses}>
			{label}
		</Typography>
	);

	const containerClasses = classNames(className, {
		"filter-sort__action--open": isOpen,
	});

	return (
		<div className={containerClasses}>
			<FloatingButton
				dismissOnFloatingClick={dismissOnFloatingClick}
				position="bottom"
				popoverClassName={popoverClassName}
				referenceComponent={buttonReference}
				floatingContent={floatingContent}
				zIndexValue={zIndexValue}
				floatingOffsetDesk={floatingOffsetDesk}
				floatingOffsetMobile={floatingOffsetMobile}
				onOpenChange={setIsOpen}
			/>
		</div>
	);
};

FlightFilterButton.propTypes = {
	className: PropTypes.string.isRequired,
	label: PropTypes.node,
	labelClassName: PropTypes.string,
	floatingContent: PropTypes.node.isRequired,
	floatingOffsetDesk: PropTypes.arrayOf(PropTypes.number),
	floatingOffsetMobile: PropTypes.arrayOf(PropTypes.number),
	zIndexValue: PropTypes.number,
	popoverClassName: PropTypes.string,
	referenceComponent: PropTypes.node,
	dismissOnFloatingClick: PropTypes.bool,
};

export default memo(FlightFilterButton);
